<template>
  <!-- START CHAT -->
    <div id="start-chat-form" v-if="activeScreen === ScreensEnum.startConversation" class="container-fluid">
        <div class="row">
            <div>
                <div class="panel">
                    <div class="clearfix panel-heading branding-background branding-text chat-heading">
                        <h3 class="panel-title pull-left">Start a Chat</h3>
                        <div class="pull-right">
                            <a @click.prevent="nextScreen(ScreensEnum.chatButton)" href="" class="branding-text min-chat" title="Minimize Chat"><i class="glyphicon glyphicon-menu-down"></i></a>
                        </div>
                    </div><!--chat-heading-->
                    <div class="panel-body">
                        <div class="form-group" :class="{'has-error' : isUserNameChangedAndInvalid}">
                            <label for="userName">Name <span class="text-danger">*</span></label>
                            <input @keyup.enter="startChat" v-model="userName" v-validate="{required: true}" name="name" type="text" class="form-control" id="userName" maxlength="@VT.DataStore.Models.VisualTour.ChatSession.InitiateNameMaxLength">
                            <span class="text-danger">{{errors.first('name')}}</span>
                        </div>
                        <div class="form-group" :class="{'has-error' : isUserPhoneChangedAndInvalid}">
                            <label for="userPhone">Phone (Text) <span class="text-danger">*</span></label>
                            <input @keyup.enter="startChat" v-model="userPhone" v-validate="{ required: true, regex: /^(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/ }" name="phone" type="text" class="form-control" id="userPhone" required placeholder="(999) 999-9999" maxlength="@VT.DataStore.Models.VisualTour.ChatSession.InitiatePhoneNumberMaxLength">
                            <span class="text-danger">{{errors.first('phone')}}</span>
                        </div>
                        <button @click="startChat" class="btn btn-lg branding-background branding-text" id="">Start Chat</button>
                    </div><!--chat-window-->
                </div><!--panel-->
            </div><!--col-->
        </div><!--row-->
    </div><!--container-->
</template>

<script>
import linkifyHtml from "linkify-html";
import screenNavMixin from "../mixins/screen-nav";
import _ from "lodash";

export default {
        mixins: [screenNavMixin],
        data: function () {
            return {
            }
        },
        computed: {
            userPhone: {
                get: function () {
                    return this.sharedStore.state.user.phone;
                },
                set: function (val) {
                    this.sharedStore.mutations.setUser({ phone: val });
                }
            },
            userName: {
                get: function () {
                    return this.sharedStore.state.user.name;
                },
                set: function (val) {
                    this.sharedStore.mutations.setUser({ name: val });
                }
            },
            isUserNameChangedAndInvalid: function () {

                if (_.isEmpty(this.fields)) {
                    return true;
                }

                return this.fields.name.changed && this.fields.name.invalid;
            },
            isUserPhoneChangedAndInvalid: function () {

                if (_.isEmpty(this.fields)) {
                    return true;
                }
                return this.fields.phone.changed && this.fields.phone.invalid;

            },
            isFormValid: function () {

                // On component init, this is empty
                // so just return false
                if (_.isEmpty(this.fields)) {
                    return false;
                }

                return this.fields.phone.valid &&
                    this.fields.name.valid;
            }
        },
        methods: {
            addAgentMessage: function (message) {
                const vm = this;
                this.sharedStore.mutations.addMessage(
                    {
                        incoming: vm.MessageDirection.Incoming,
                        name: vm.sharedStore.state.agent.name,
                        message: linkifyHtml(message.body, {
                            defaultProtocol: 'http',
                            tagName: 'a',
                            target: {
                                url: '_blank'
                            }
                        })
                    }
                );
            },
            onMessageAdded: function (newMessage) {
                this.addAgentMessage(newMessage);
            },
            onConversationRemoved: function () {

                this.$chatService.updateConversation({ Active: false });
                this.sharedStore.mutations.setActiveChat(false);
            },
            onConversationJoined: function () {

                //this.$chatService.updateChannel({ Active: true });
                this.sharedStore.mutations.setActiveChat(true);
            },
            onParticipantJoined: function () {
                console.log('Participant has joined discussion');
            },
            startChat: function () {

                this.$validator.validate()
                    .then(function (isValid) {

                        // If not valid then return
                        if (!isValid) {
                            return;
                        }

                        // Reset any previous chat State before continuing
                        this.sharedStore.mutations.resetChat();

                        // Call to setup chat chanel
                        const context = this;
                        context.$chatService.setupChat()
                            .then(function (twilio) {
                                // Setup event handlers for chat client and channel
                                // before joining channel so we can respond to these events in vue
                                twilio.activeConversation.on('messageAdded', context.onMessageAdded);
                                twilio.conversationClient.on('conversationJoined', context.onConversationJoined);
                                twilio.conversationClient.on('conversationRemoved', context.onConversationRemoved);
                                twilio.conversationClient.on('participantJoined', context.onParticipantJoined);

                                // Join the channel will fire event that will update the db record
                                return context.$chatService.joinConversation(twilio.activeConversation);

                            })
                            .then(function () {

                                const payload = {
                                    InitiateName: context.sharedStore.state.user.name,
                                    InitiateEmail: context.sharedStore.state.user.email,
                                    IncomingNumber: context.sharedStore.state.agent.phone,
                                    InitiatePhone: context.sharedStore.state.user.phone,
                                    InitiateIpAddress: context.sharedStore.state.browser.ip,
                                    InitiateTimezone: context.sharedStore.state.browser.timeZone,
                                    InitiateUserAgent: context.sharedStore.state.browser.userAgent,
                                    UserId: context.sharedStore.state.agent.userId                                  
                                };

                                // Add Tourid or SocialMediaPost Id
                                if(context.sharedStore.state.tour){
                                    payload.TourId = context.sharedStore.state.tour.tourId;
                                }

                                if(context.sharedStore.state.socialMediaPost){
                                    payload.SocialMediaPostId = context.sharedStore.state.socialMediaPost.socialMediaPostId;
                                }

                                // Update channel will create the record in db
                                return context.$chatService.updateConversation(payload);

                            }).catch(function (err) {
                                console.log(err);
                            });

                        // Set active chat flag
                        this.sharedStore.mutations.setActiveChat(true);
                        this.nextScreen(this.ScreensEnum.conversationClient);

                    }.bind(this));

            },
            endChat: function () {

                this.$chatService.endChat();
                this.nextScreen(this.ScreensEnum.conversationClient);
            }
        }
};
</script>

<style>
</style>